import React from 'react'
import AdmBookSearch from '../../components/AdminTabs/AdminBookSearch/AdmBookSearch'

const BookSearch = () => {
  return (
    <>
<AdmBookSearch />
    </>
  )
}

export default BookSearch